import { render, staticRenderFns } from "./ImpactBox.vue?vue&type=template&id=9d8ea91c&scoped=true&"
import script from "./ImpactBox.vue?vue&type=script&lang=ts&"
export * from "./ImpactBox.vue?vue&type=script&lang=ts&"
import style0 from "./ImpactBox.vue?vue&type=style&index=0&id=9d8ea91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8ea91c",
  null
  
)

export default component.exports